import { graphql, HttpResponse } from 'msw'
import { type EnrollmentMultiWelcomeData, type EnrollmentMultiWelcomeSubmitOutput } from '../../../../models'

export const getEnrollmentMultiWelcomeDataMock: EnrollmentMultiWelcomeData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/welcome',
  enrollmentData: {
    applicationId: '305802305',
    firstName: 'Johnathan',
    progress: 0.5,
  },
}

export const submitEnrollmentMultiWelcomeDataMock: EnrollmentMultiWelcomeSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/fund-account',
}

export const mockGetEnrollmentMultiWelcomeData = graphql.mutation('getEnrollmentMultiWelcomeData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentMultiWelcomeDataMock } })
})

export const mockSubmitEnrollmentMultiWelcomeData = graphql.mutation('submitEnrollmentMultiWelcomeData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentMultiWelcomeDataMock } })
})

export const mockEnrollmentMultiWelcome = [mockGetEnrollmentMultiWelcomeData, mockSubmitEnrollmentMultiWelcomeData]
